export enum ProductSearchType {
  RooftopTentsRackSelector,
  SelectList,
  VariationSelector,
  LoadingFromCookie,
}

export default ProductSearchType;
